import React from 'react';
import {Link} from 'react-router-dom';
import { Facebook, Instagram ,Mail, Phone, MapPin } from 'lucide-react';
const PinterestIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);
const getCurrentYear = () => new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="bg-dark-900 text-white">

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info with Logo */}
          <div>
            {/* Logo Image */}
            <div className="mb-4 flex items-center gap-3">
              <a href="/">
              <img 
                src={`${process.env.PUBLIC_URL || ''}/images/logo/skyf-monogram.png`}
                alt="Sky Furniture Canada monogram"
                width="512" height="512"
                className="h-16 w-auto rounded-2xl"
              />
              </a>
              <a href="/"><h4 className="text-lg font-display font-bold">Sky Furniture Canada</h4></a>
            </div>
            
            <p className="text-gray-400 mb-4">
              Your trusted source for affordable furniture. Transforming houses into dream homes across Canada.
            </p>
            
            {/* Social Media Icons */}
            <div className="flex gap-3">
              <a 
                href="https://facebook.com/skyfurniturecanada" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://Instagram.com/skyfurnitureca" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://ca.pinterest.com/skyfurnitureca/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Pinterest"
              >
                <PinterestIcon className="w-5 h-5" />
              </a>
              <a 
                href="https://wa.me/16478726713" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="WhatsApp"
              >
                <svg className="w-6 h-6" viewBox="0 0 448 512" fill="currentColor">
                  <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3 18.6-68.1-4.4-6.9c-18.4-28.7-28.1-61.9-28.1-95.8C46.8 139.7 131.6 54.9 224 54.9c41.3 0 80.2 16.1 109.5 45.4 29.3 29.3 45.4 68.2 45.4 109.5 0 92.5-84.9 177.3-177.4 177.3zm-63.1-137.9c-2.3-1.1-13.7-6.8-15.8-7.5-2.1-.7-3.6-1.1-5.1 1.1-1.5 2.2-5.9 7.5-7.3 9-.9 1.1-1.7 1.2-4.1 0-2.4-1.2-10.1-3.7-19.2-11.9-7.1-6.4-11.8-14.2-13.2-16.5-.4-.6-.1-.9.3-1.2.3-.3.7-.8 1.1-1.2.4-.4.5-.7.8-1.1.3-.4.2-.8-.1-1.1-.3-.3-1.2-2.9-1.6-4-.4-1.1-.8-1-1.1-1.1h-1.1c-.4 0-1.1.1-1.7.3-.6.2-1.5.7-2.3 1.6-1.5 1.7-5.8 5.7-5.8 13.9 0 8.2 5.9 16.1 6.7 17.2.1 1.1 9.4 14.3 22.8 20.1 3.2 1.4 5.7 2.2 7.7 2.8 3.2 1 6.2.9 8.5.5 2.6-.4 8.2-3.4 9.4-6.6 1.2-3.1 1.2-5.8.8-6.4-.3-.6-1.1-.9-2.3-1.5z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className='pt-4'>
            <h4 className="text-lg font-display font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Store Locations
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className='pt-4'>
            <h4 className="text-lg font-display font-bold mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/shipping" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Shipping Information
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors duration-300">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/warranty" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Warranty Information
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors duration-300">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className='pt-4'>
            <h4 className="text-lg font-display font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary-400 flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                  70 Belfield Road<br />
                  Etobicoke, ON
                  <br />
                  <span className="text-xs">Serving: GTA, Windsor-Ottawa-London, Niagara-Waterloo-Barrie</span>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <a href="tel:+16478726713" className="text-gray-400 hover:text-white transition-colors duration-300">
                  +1 (647) 872-6713
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <a href="mailto:info@skyfurniturecanada.com" className="text-gray-400 hover:text-white transition-colors duration-300">
                  info@skyfurniturecanada.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-gray-400 text-center text-sm">
              Â© {getCurrentYear()} Sky Furniture. All rights reserved.
            </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
